// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buy-btn{display:none}.v-btn{border-radius:25px}.v-btn .v-btn__content{text-transform:none}.fxt-buy-btn .v-btn__content{color:#fff}", ""]);
// Exports
module.exports = exports;
